import { BaseTool } from '../BaseTool';

export class ModifyToposolidTool extends BaseTool {
    id = 'CONTEXT_TOPOSOLID_MODIFY';
    name = 'Modify Toposolid';
    cursor = 'default';

    onActivate(): void {
        console.log('Activating Modify Toposolid Context...');
        // Enable sub-element selection for Toposolid vertices/edges
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

export class RebarContextTool extends BaseTool {
    id = 'CONTEXT_REBAR';
    name = 'Rebar Context';
    cursor = 'default';

    onActivate(): void {
        console.log('Activating Rebar Context...');
        // Enable Rebar specific placement options/host selection
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
